import classNames from 'classnames';
import { convertToPluralIfNeeded, downloadAlbumWithMediaToQueueItem, State, streamMediaWithAlbumToQueueItem, useHubSwitch, usePlayerState } from '@bpm-web-app/utils';
import { Playlist as DownloadPlaylist, PlaylistWithAlbum } from '@bpm-web-app/download-api-sdk';
import { PlaylistWithMedia } from '@bpm-web-app/stream-api-sdk';
import { useCallback } from 'react';
import { Playlist as PlaylistAPI } from '@bpm-web-app/api-client';
import styles from './predictive-search.module.css';
import { AppLink } from '../shared';
import { RowComponent } from '../row-component/row-component';
import { usePlayer } from '../player-context';

export interface PlaylistProps {
    playlists?: DownloadPlaylist[];
    count?: number
}

export default function Playlist({ playlists, count }: PlaylistProps) {
    const { setQueue, originalListDetails, onPause, silenceWorkaround } = usePlayer();
    const { isDownload } = useHubSwitch();
    const playerState = usePlayerState();

    const isPlaying = useCallback((id: number) => {
        if (playerState !== State.Playing) {
            return false;
        }
        return originalListDetails?.identifier === `${id}` && originalListDetails?.resource === 'exclusive-playlist';
    }, [playerState, originalListDetails]);

    const handlePlaySong = useCallback(async (set: DownloadPlaylist) => {
        try {
            // Can't use SWR because it's a hook
            // eslint-disable-next-line max-len
            // TODO: Maybe try to check if SWR cache can help to avoid a bit more fetch without the help of SWR?
            silenceWorkaround();
            const { data } = await PlaylistAPI.getPlaylistDetail(isDownload, Number(set.id));
            if (!data) return;

            const queueMedia = isDownload
                ? (data as PlaylistWithAlbum).albums?.map((curatedSetAlbum) => downloadAlbumWithMediaToQueueItem(curatedSetAlbum))
                : (data as PlaylistWithMedia).media?.map((curatedSetMedia) => streamMediaWithAlbumToQueueItem(curatedSetMedia));
            if (queueMedia) { setQueue(queueMedia, 0, { identifier: `${set.id}`, resource: 'exclusive-playlist' }); }
            // eslint-disable-next-line no-empty
        } catch (error: any) {
        }
    }, [isDownload, setQueue, silenceWorkaround]);

    return (
        <>
            <div className={styles['predictive-search__row-container']}>
                <h4 className={styles['predictive-search__title']}>{convertToPluralIfNeeded(count || 0, 'Playlists', 'Playlists', true)}</h4>
            </div>
            <div>
                {playlists?.length === 0 ? (
                    <div className={styles['predictive-search__list']}><h5 className={classNames(styles['predictive-search__content-title'], styles['predictive-search__content-title-empty'])}>No items match your search</h5></div>
                ) : (
                    playlists?.map((item) => (
                        <AppLink href={`/exclusive-playlist/${item.id}`} key={item.id}>
                            <RowComponent
                                type="playlist"
                                onCoverClick={() => isPlaying(item.id) ? onPause() : (handlePlaySong(item))}
                                isPlaying={isPlaying(item.id)}
                                id={item.id}
                                cover_url={item.image_url}
                                title={item.title}
                                artist={item.artist}
                                artists={item.artists}
                                hasHover
                            />
                        </AppLink>
                    ))
                )}
            </div>
        </>
    );
}
